import _ from "lodash";

interface ModuleLocales {
    name?: string;
    sensors?: Record<string, string>;
}

export function flattenModuleMessages(modulesJson: { modules: Record<string, ModuleLocales> }): Record<string, string> {
    const sensorKeys = _(modulesJson.modules)
        .map((m, moduleKey) => {
            return _(m.sensors || {})
                .map((sensorName, sensorKey) => {
                    const normalizedKey = sensorKey
                        .split(".")
                        .map((p) => _.camelCase(p).replace("10M", "10m").replace("2M", "2m"))
                        .join(".");

                    if (moduleKey.indexOf("wh.") == 0) {
                        const fullKey = [moduleKey, normalizedKey].join(".");
                        return [fullKey, sensorName];
                    }

                    const fullKey = ["fk", moduleKey, normalizedKey].join(".");
                    return [fullKey, sensorName];
                })
                .value();
        })
        .flatten()
        .fromPairs()
        .value();

    const moduleKeys = _(modulesJson.modules)
        .map((m, moduleKey) => {
            if (!m.name) {
                return null;
            }

            if (moduleKey.startsWith("wh.")) {
                return [moduleKey, m.name];
            }
            return ["fk." + moduleKey, m.name];
        })
        .compact()
        .fromPairs()
        .value();

    return {
        ...sensorKeys,
        ...moduleKeys,
    };
}
